import { Component, Input } from '@angular/core';

@Component({
  selector: 'cm-skeleton-fade',
  templateUrl: './skeleton-fade.component.html',
  styleUrls: ['./skeleton-fade.component.scss'],
})
export class SkeletonFadeComponent {
  @Input() width = '100%';
  @Input() height = '20px';
  @Input() borderRadius = '4px';
  @Input() count = 1;
  @Input() appearance: 'default' | 'rounded' | 'chip' = 'default';
  @Input() marginBottom = 12;

  constructor() {}
}
